import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonProgressBar,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import { close } from 'ionicons/icons';
import React, { memo } from 'react';
import ApiKeysForm from '../components/ApiKeysForm';
import { LoadFailureStateContainer, LoadingStateContainer } from '../components/StateContainer';
import { useTranslation } from '../hooks/useTranslation';
import { useUserApiKeysQuery } from '../query/userApiKeysQuery';

interface ApiKeysModalProps {
    dismiss: (data?: string | null, role?: string) => void;
}

const ApiKeysModal: React.FC<ApiKeysModalProps> = ({ dismiss }) => {
    const { t } = useTranslation('modals');
    const apiKeysQuery = useUserApiKeysQuery();

    return (
        <IonPage>
            <IonHeader translucent>
                <IonToolbar>
                    <IonTitle>{t('api_keys.title')}</IonTitle>
                    <IonButtons slot="primary">
                        <IonButton aria-label={t('api_keys.close')} onClick={() => dismiss(null, 'cancel')}>
                            <IonIcon slot="icon-only" icon={close} />
                        </IonButton>
                    </IonButtons>
                    {(apiKeysQuery.isLoading || apiKeysQuery.isFetching) && <IonProgressBar type="indeterminate" />}
                </IonToolbar>
            </IonHeader>
            <IonContent color="light" fullscreen>
                {apiKeysQuery.isLoading && <LoadingStateContainer />}
                {apiKeysQuery.isError && (
                    <LoadFailureStateContainer
                        subtitle={t('api_keys.failed_to_load')}
                        error={apiKeysQuery.error as Error}
                        onRetry={() => apiKeysQuery.refetch()}
                    />
                )}
                {apiKeysQuery.data && <ApiKeysForm apiKeys={apiKeysQuery.data} />}
            </IonContent>
        </IonPage>
    );
};

export default memo(ApiKeysModal);
